import axios from 'axios';
import { getLocalStorage, LOCAL_STORAGE_KEY_ACCESS_TOKEN } from "../commom/localStorage";
import { extrairDominioPai, GetGaUserCode, GetUserIdCookie } from "../commom/userCode";
import Cookies from 'universal-cookie';
import env from "../env";

const axiosInstance = axios.create({
  baseURL: env.REACT_APP_API_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token_key = env.REACT_APP_COOKIE_NAME;
    const cookies = new Cookies(null, { path: '/', domain: extrairDominioPai() });
        
    const bt_token = cookies.get(token_key);
    const token = bt_token || getLocalStorage(LOCAL_STORAGE_KEY_ACCESS_TOKEN);
        
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers.Platform = 'aprova-universitario';

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.request.use(
  (config) => {
    if (config.method === 'post') {
      config.data = {
        ...config.data,
        uniqueGaId: GetGaUserCode(),
        userIdCookie: GetUserIdCookie()
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && (error.response.status === 403 || error.response.status === 401)) {
      window.location.href = '/logout';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
